import React from 'react';

const statusItems = [
    {
        label: 'Connected',
        icon: 'https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/signal-stream.svg',
        key: 'connected',
    },
    {
        label: 'Recognized',
        icon: 'https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/security.svg',
        key: 'recognized',
    },
    {
        label: 'Engaged',
        icon: 'https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/icon-engaged.svg',
        key: 'engaged',
    },
];

const tooltipText="These insights are derived from our centralized repository of all online, telephonic and offline alumni activities that show whether the institute is in contact with the alumnus through any communication channel, and whether the alumnus has been recognized by institute in some form.";

const AlumniRecognitionStatus = ({ engagementData }: any) => {
    return (
        <div className="col-12 mt-md-auto">
            <div className="row g-2">
                {statusItems.map((item, index) => {
                            const value = engagementData?.[item.key];
                            const isYes = value?.toLowerCase() === 'yes';

                            const wrapperClass = isYes
                            ? 'bg-green-5CAE4814 text-green'
                            : 'bg-gray-E6E6E6 text-gray-41';

                            return (
                                <div className="col-auto" key={index}>
                                    <div className={`p-2 d-flex align-items-center rounded-2 ${wrapperClass}`}>
                                        <img src={item.icon} width="20" className="me-2" alt={item.label} />
                                        <span className="flex-1 font-500 me-2">{item.label}</span>
                                        {isYes && <i className="icon-correct font-14"></i>}
                                    </div>
                                </div>
                            );
                        })}
                <div className="col-auto">
                    <div className="line d-flex align-items-center h-100">
                        <span className="p-2 bg-white position-relative d-flex align-items-center">
                            <i
                                className="icon-info text-gray-64"
                                data-bs-toggle="tooltip"
                                title=""
                                data-bs-original-title={tooltipText}
                                aria-label={tooltipText}
                            ></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlumniRecognitionStatus;
